<template>
    <div>
        <BCard v-if="movement">
            <BRow>
                <BCol cols="12" xl="6">
                    <table class="mt-2 mt-xl-0 w-100">
                        <ViewData vsIcon="UserIcon" vsLabel="Movement" :vsValue="movement.movement_type.name" />
                    </table>
                </BCol>
                <BCol cols="12" xl="6">
                    <table class="mt-2 mt-xl-0 w-100">
                        <ViewData vsIcon="UserIcon" vsLabel="Amount" :vsValue="movement.amount" />
                    </table>
                </BCol>
                <BCol cols="12" xl="6">
                    <table class="mt-2 mt-xl-0 w-100">
                        <ViewData vsIcon="UserIcon" vsLabel="date" :vsValue="movement.emit_date" />
                    </table>
                </BCol>
                <BCol cols="12" xl="6">
                    <table class="mt-2 mt-xl-0 w-100">
                        <ViewData vsIcon="HomeIcon" vsLabel="Cash" :vsValue="movement.cash_register.name" />
                    </table>
                </BCol>
                <BCol cols="12" xl="6">
                    <table class="mt-2 mt-xl-0 w-100">
                        <ViewData vsIcon="HomeIcon" vsLabel="Observations" :vsValue="movement.observations" />
                    </table>
                </BCol>
                <BCol cols="12" xl="6">
                    <table class="mt-2 mt-xl-0 w-100">
                        <ViewData vsIcon="HomeIcon" vsLabel="References" :vsValue="movement.invoice ? movement.invoice.name : (movement.expense ? movement.expense.name : '')" />
                    </table>
                </BCol>
                <BCol cols="12" class="pt-3">
                    <div class="d-flex flex-wrap">
                        <BButton :to="{ name: 'cash-movements-edit', params: { id: movement.id } }" variant="primary" v-if="ability.can('write', 'movement')"> {{$t('Edit')}} </BButton>
                        <BButton variant="outline-danger" class="ml-1" @click="deletePopup(movement.id, 'movements/deleteMovement', 'cash-selector')" v-if="ability.can('delete', 'movement')"> {{$t('Delete')}} </BButton>
                    </div>
                </BCol>
            </BRow>
        </BCard>

        <BModal ref="movement_export_modal" centered hide-footer >
            <p>Introduzca las fechas: </p>
            <BRow>
                <DatepickerValidated vsName="Start date" :vsModel.sync="startDateModal" vsRequired/>
                <DatepickerValidated vsName="End date" :vsModel.sync="endDateModal" vsRequired :vsMin="startDateModal"/>
                <BCol>
                <BButton @click="exportMovements(cash.id, typeExportSelected, true)" variant="primary">Exportar</BButton>
                </BCol>
            </BRow>
        </BModal>
    </div>
</template>
<script>
import { BButton, BCard, BCardBody, BCardSubTitle, BCardTitle, BCol, BRow, BFormInput, BDropdown, BDropdownItem } from 'bootstrap-vue'
import { provide, ref } from '@vue/composition-api'
import DatepickerValidated from '@/components/forms/DatepickerValidated.vue'
import ViewData from '@/components/ViewData.vue'
import ability from '@/libs/acl/ability'
import exportUtils from '@/hooks/exportUtils'
import popups from '@/hooks/popups'
import router from '@/router'
import axios from '@axios'
import cashMovementsModule from '../cashMovementsModule';
import store from '@/store';
import { onUnmounted } from '@vue/composition-api';



export default {
    components: { ViewData, DatepickerValidated, BButton, BCard, BRow, BCol, BCardBody, BCardTitle, BCardSubTitle, BFormInput, BDropdown, BDropdownItem },
    setup() {
        const { exportData } = exportUtils()
        const { deletePopup, successToast, errorToast } = popups()
        const movement = ref(null)
        const movement_export_modal = ref('')
        const typeExportSelected=ref(null)
        const startDateModal=ref(null)
        const endDateModal=ref(null)

        const CASH_MOVEMENTS_MODULE = 'movements'

        if(!store.hasModule(CASH_MOVEMENTS_MODULE)){
            store.registerModule(CASH_MOVEMENTS_MODULE, cashMovementsModule)
        }

        onUnmounted(() => {
            if(store.hasModule(CASH_MOVEMENTS_MODULE)) {
                store.unregisterModule(CASH_MOVEMENTS_MODULE)
            }
        })
      
        //& Consultas
        axios.get(`movements/${router.currentRoute.params.id}`).then(response => {
            movement.value = response.data.movement
        })

        provide('movement', movement)

        //& Métodos 

        /**
         * Exportar movimientos
         */
        const exportMovements = (id, fileType, datesSelected) => {
            if (datesSelected) {
                if (!startDateModal.value) {
                    errorToast("Selecciona una fecha de comienzo.")
                    return
                }

                if (!endDateModal.value) {
                    errorToast("Selecciona una fecha de fin")
                    return
                }

                let data = {
                    id: id, 
                    start_date: startDateModal.value,
                    end_date: endDateModal.value, 
                    type: fileType
                }
                let name = `listadoMovimientos_${startDateModal.value}_${endDateModal.value}`
                if(exportData('movements/export', data, name, fileType)) {
                    startDateModal.value = null
                    endDateModal.value = null
                    movement_export_modal.value.hide()
                    successToast(`${fileType} descargado`)
                }else{
                    errorToast(`No ha sido posible descargar el ${fileType}`)
                }            
            }
        }

        const exportMovementsPDF = () => {
            startDateModal.value = null
            endDateModal.value = null
            movement_export_modal.value.show()
            typeExportSelected.value = "PDF"
        }

        const exportMovementsCSV = () => {
          startDateModal.value=null
          endDateModal.value=null
          movement_export_modal.value.show()
          typeExportSelected.value="CSV"
        }

        const exportMovementsXLS = () => {
          startDateModal.value=null
          endDateModal.value=null
          movement_export_modal.value.show()
          typeExportSelected.value="XLS"
        }





        return {
            deletePopup,
            ability,
            movement,
            exportMovementsPDF,
            exportMovementsCSV,
            exportMovementsXLS,
            startDateModal,
            endDateModal,
            movement_export_modal,
            exportMovements,
            typeExportSelected
        }
    },
}


</script>
